import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  in_progress: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
  },
  overdue: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  },
  finalized: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },
}))

export default useStyles
